module.exports = __webpack_public_path__ + "img/logobew.984d90ad.svg";